<template>
    <section class="gmp-section gmp-mb-l">

        <div class="two-column-tout two-column-tout--fullbleed">
            <div class="two-column-tout__side h-c-grid__col-l--order-2">
                <div class="two-column-tout__half-page two-column-tout__half-page--right">
                    <div class="two-column-tout__half-grid two-column-tout__half-grid--right">
                        <div class="two-column-tout__col two-column-tout__col--large">
                            <h3 class="h-c-headline h-c-headline--one">
                                非常细微而实用的功能
                            </h3>
                            <p class="h-u-mb-std two-column-tout__description">
                                这套系统实现集中管理、降低成本、确保品质一致性，以及提高运营效率，进一步增强其市场竞争力
                            </p>
                            <a  @click="toEnterprisePage('/enterprise/directStore/DS_Special','/enterprise/directStore/DS_Special')"   class="h-c-link h-c-link--internal gmp-link">
                                查看所有特点</a>
                        </div>

                    </div>

                </div>
            </div>
            <div class="two-column-tout__side h-c-grid__col-l--order-1">
                <div class="two-column-tout__image two-column-tout__image--left">
                    <picture>
                        <img src="@/assets/img/twobleed.png" alt="" class="gmp-no-grab " >
                    </picture>

                </div>
            </div>

        </div>


    </section>
</template>

<script>
    export default {
        name: "EB_two_column_fullbleed",


        methods:{
            toEnterprisePage(data, url) {
                this.$router.push(data)
                this.$('body').removeClass('h-is-showing-drawer');
                var lis = this.$('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < lis.length; i++) {
                    var toWhere = this.$(lis[i]).attr('to-where');
                    console.log("toWhere===" + toWhere);
                    if (toWhere === url) {
                        this.$(lis[i]).addClass('h-is-active');
                    } else {
                        this.$(lis[i]).removeClass('h-is-active')
                    }
                }
            },
        }
    }
</script>

<style lang="less">


</style>